<div class="add-course-dialog">
  <div class="add-course-dialog__header">
    <h2 mat-dialog-title class="add-course-dialog__title">{{ data.title }}</h2>
    <button
      type="button"
      class="add-course-dialog__close"
      (click)="close()"
      aria-label="Close add new course dialog"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5 5L15 15"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
        />
        <path
          d="M15 5L5 15"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="add-course-dialog__content">
    <form
      class="add-course-dialog__form"
      [formGroup]="addCourseForm"
      (ngSubmit)="submit()"
    >
      <div class="add-course-dialog__field">
        <label class="add-course-dialog__label" for="add-course-code">
          {{ data.courseCodeLabel }}
          <span class="add-course-dialog__required" aria-hidden="true">*</span>
        </label>
        <input
          id="add-course-code"
          class="add-course-dialog__input"
          type="text"
          formControlName="courseCode"
          autocomplete="off"
          placeholder="eg. MAC/201"
          [attr.aria-label]="data.courseCodeLabel"
          [attr.aria-describedby]="
            addCourseForm.controls.courseCode.invalid &&
            addCourseForm.controls.courseCode.touched
              ? 'add-course-code-error'
              : null
          "
        />
      </div>

      <div class="add-course-dialog__field">
        <label class="add-course-dialog__label" for="add-course-name">
          {{ data.courseNameLabel }}
          <span class="add-course-dialog__required" aria-hidden="true">*</span>
        </label>
        <input
          id="add-course-name"
          class="add-course-dialog__input"
          type="text"
          formControlName="courseName"
          autocomplete="off"
          placeholder="eg. Media and Society"
          [attr.aria-label]="data.courseNameLabel"
          [attr.aria-describedby]="
            addCourseForm.controls.courseName.invalid &&
            addCourseForm.controls.courseName.touched
              ? 'add-course-name-error'
              : null
          "
        />
      </div>

      <mat-dialog-actions align="end" class="add-course-dialog__actions">
        <button
          type="button"
          class="add-course-dialog__cancel"
          (click)="close()"
        >
          {{ data.cancelLabel }}
        </button>
        <button
          type="submit"
          class="add-course-dialog__confirm"
          [disabled]="addCourseForm.invalid"
        >
          {{ data.confirmLabel }}
        </button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>